module.exports = __webpack_public_path__ + "assets/measure_vehicle_distance.6c067c87.svg";